import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { useSelector } from 'react-redux';

import { IStore } from 'src/explore/types/store';

import Authentication from './atoms/Authentication';
import Link from './atoms/Link';

const Account: FC = () => {
  const account = useSelector(( state: IStore ) => state.data.account );

  return account.data ? (
    <Link>
      <FontAwesomeIcon icon={faUser} />
    </Link>
  ) : (
    <Authentication>
      <FontAwesomeIcon icon={faUser} />
    </Authentication>
  );
};

export default Account;
